import { useState } from "react";
import { useTranslation } from "react-i18next";

import { NavItem, NavLink, TabsWrap } from "@/shared/components/Tabs";
import { isObjEmpty } from "../../../shared/helpers";
import ScheduledTripDetailsForm from "./ScheduledTripDetailsForm";
import { TabPane } from "../TripsForm";
import { Nav, Tab } from "react-bootstrap";

const ScheduledTripTabs = ({
  rowData,
  type,
  fillupsData,
  setFillupsData,
  expensesData,
  setExpensesData,
  incomeData,
  setIncomeData,
  newRecordData,
  setNewRecordData,
  vehicle,
  driver,
  tripDocs,
  setTripDocs,
  firstTimeEdit,
  errors,
  userOptions,
  setUserOptions,
  tripType
}) => {
  const { t } = useTranslation("common");
  const [activeKey, setActiveKey] = useState("1");

  return (
    <Tab.Container
      defaultActiveKey="1"
      activeKey={activeKey}
      onSelect={(e) => setActiveKey(e)}
    >
      <TabsWrap>
        <Nav className="nav-tabs">
          <NavItem $active={activeKey == 1}>
            <NavLink eventKey="1">
              {t("trip_details")}{" "}
              {!isObjEmpty(errors) && (
                <i
                  className="fi fi-rr-triangle-warning"
                  style={{
                    color: "red",
                    position: "relative",
                    top: "2px",
                  }}
                ></i>
              )}
            </NavLink>
          </NavItem>
        </Nav>
        <Tab.Content>
          <TabPane
            eventKey="1"
            $edit={type === "edit"}
            // style={{
            //   height: `${window.innerHeight - 200}px`,
            //   overflow: "auto",
            // }}
          >
            <ScheduledTripDetailsForm
              rowData={rowData}
              type={type}
              tripDocs={tripDocs}
              setTripDocs={setTripDocs}
              firstTimeEdit={firstTimeEdit}
              userOptions={userOptions}
              setUserOptions={setUserOptions}
              tripType={tripType}
              //userInfo={userInfo}
            />
          </TabPane>
        </Tab.Content>
      </TabsWrap>
    </Tab.Container>
  );
};

export default ScheduledTripTabs;
